export const webURL = 'https://www.artoflogic.ai';

export const card1Text = 'ALPR-powered vehicle recognition and parking enforcement. Track license plates and ensure smooth access, security, and compliance.';
export const card2Text = 'Advanced people and object detection with Re-ID. Track movement, dwell time, queues, and crossing lines for precise insights. Enhance operations with real-time analytics and BI integration.';
export const card3Text = 'Real-time diagnostics, proactive alerts, and centralized insights to prevent downtime and optimize performance.';

// external urls
export const roninURL = 'https://ronin.artoflogic.ai';
export const roninHealthInfoURL = 'https://ronin.artoflogic.ai/#/health';
export const shogunURL = 'https://shogun.artoflogic.ai';

// devlopment urls
// export const roninURL = 'http://192.168.1.32:3001';
// export const shogunURL = 'http://192.168.1.32:3002';


export const policyNames = [
    '1-Channel Samurai Count',
    '2-Channel Samurai Count',
    '4-Channel Samurai Count',
    '1-Channel Samurai Detect',
    '2-Channel Samurai Detect',
    '4-Channel Samurai Detect',
    '6-Channel Health Monitoring',
    '50-Channel Health Monitoring',
    '100-Channel Health Monitoring',
    '4-Channel Parking Management',
    '2-Channel Parking Management',
    '4-Channel Corsight',
    '2-channel Object',
    '50-Channel Health Monitoring Demo',
    '4-Channel Samurai Count Demo',
    '4-Channel Samurai Detect Demo'
  ];

  export const reportFooter = '© 2023 Art of Logic Pty Ltd. All rights reserved.';